var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-toolbar-blocks",
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-toolbar-tool-header",
          attrs: {
            id: "cw-toolbar-blocks-header",
          },
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function submit($event) {
                  $event.preventDefault()
                  return _vm.loadSearch.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "input-group files-search search cw-block-search",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchInput,
                        expression: "searchInput",
                      },
                    ],
                    ref: "searchBox",
                    attrs: {
                      type: "text",
                      label: _vm.$gettext(
                        "Geben Sie einen Suchbegriff mit mindestens 3 Zeichen ein."
                      ),
                    },
                    domProps: {
                      value: _vm.searchInput,
                    },
                    on: {
                      click: function click($event) {
                        $event.stopPropagation()
                      },
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.searchInput = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "input-group-append",
                      on: {
                        click: function click($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _vm.searchInput
                        ? _c(
                            "button",
                            {
                              staticClass: "button reset-search",
                              attrs: {
                                type: "button",
                                id: "reset-search",
                                title: _vm.$gettext("Suche zurücksetzen"),
                              },
                              on: {
                                click: _vm.resetSearch,
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "decline",
                                  size: 20,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          attrs: {
                            type: "submit",
                            id: "search-btn",
                            title: _vm.$gettext("Suche starten"),
                          },
                          on: {
                            click: _vm.loadSearch,
                          },
                        },
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "search",
                              size: 20,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filterpanel",
              attrs: {
                id: "filterpanel",
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "sr-only",
                },
                [_vm._v(_vm._s(_vm.$gettext("Kategorien-Filter")))]
              ),
              _vm._v(" "),
              _vm._l(_vm.blockCategories, function (category) {
                return _c(
                  "button",
                  {
                    key: category.type,
                    staticClass: "button",
                    class: {
                      "button-active":
                        category.type === _vm.currentFilterCategory,
                    },
                    attrs: {
                      "aria-pressed":
                        category.type === _vm.currentFilterCategory
                          ? "true"
                          : "false",
                    },
                    on: {
                      click: function click($event) {
                        return _vm.selectCategory(category.type)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(category.title) +
                        "\n            "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-toolbar-tool-content",
          style: _vm.toolContentStyle,
        },
        [
          _vm.filteredBlockTypes.length > 0
            ? _c(
                "div",
                {
                  staticClass: "cw-blockadder-item-list",
                },
                [
                  _vm.filteredBlockTypes.length > 0
                    ? _c(
                        "draggable",
                        {
                          ref: "sortables",
                          staticClass: "cw-blockadder-item-list",
                          attrs: {
                            tag: "ul",
                            role: "listbox",
                            handle: ".cw-sortable-handle-blockadder",
                            group: {
                              name: "blocks",
                              pull: "clone",
                              put: "false",
                            },
                            clone: _vm.cloneBlock,
                            sort: false,
                            emptyInsertThreshold: 20,
                            sectionId: "0",
                          },
                          on: {
                            start: function start($event) {
                              return _vm.dragBlockStart($event)
                            },
                            end: function end($event) {
                              return _vm.dropNewBlock($event)
                            },
                          },
                          model: {
                            value: _vm.filteredBlockTypes,
                            callback: function callback($$v) {
                              _vm.filteredBlockTypes = $$v
                            },
                            expression: "filteredBlockTypes",
                          },
                        },
                        _vm._l(_vm.filteredBlockTypes, function (block, index) {
                          return _c("courseware-blockadder-item", {
                            key: index,
                            attrs: {
                              title: block.title,
                              type: block.type,
                              "data-blocktype": block.type,
                              description: block.description,
                            },
                            on: {
                              blockAdded: function blockAdded($event) {
                                return _vm.$emit("blockAdded")
                              },
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c("courseware-companion-box", {
                attrs: {
                  msgCompanion: _vm.$gettext(
                    "Es wurden keine passenden Blöcke gefunden."
                  ),
                  mood: "pointing",
                },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }